import React from "react";
import "./backButton.css";
import { Link } from "react-router-dom";

const BackButton = () => {
  return (
    <div className="back__button">
      <Link to="/category" className="back__link__text">
        {" "}
        {"< 戻る"}
      </Link>
    </div>
  );
};

export default BackButton;
